import { render, staticRenderFns } from "./FileChooserFolderItem.vue?vue&type=template&id=e1c7b964&v-if=folderIsReadable&"
import script from "./FileChooserFolderItem.vue?vue&type=script&lang=js&"
export * from "./FileChooserFolderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports